import {
  CalendarIcon,
  UserCircleIcon,
  DesktopComputerIcon,
  BookOpenIcon,
  ClockIcon,
  AcademicCapIcon,
  PuzzleIcon,
  SparklesIcon,
  MailIcon,
  StarIcon,
  ChatAlt2Icon,
  FireIcon,
  LightBulbIcon,
  TrendingUpIcon,
  HeartIcon,
  CloudIcon,
  PencilIcon,
  CursorClickIcon,
  VideoCameraIcon,
  UserGroupIcon,
  TicketIcon,
  ReceiptTaxIcon,
  BriefcaseIcon,
  AtSymbolIcon,
  LocationMarkerIcon,
  ChevronDoubleDownIcon,
  ExclamationCircleIcon,
  PlusIcon,
  XIcon,
} from '@heroicons/react/outline';
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@heroicons/react/solid';
import ArrowRightDownIcon from './icons/ArrowRightDownIcon';
import ArrowRightDownSolidIcon from './icons/ArrowRightDownSolidIcon';
import ArrowRightUpCircle from './icons/ArrowRightUpCircle';
import DiscordIcon from './icons/DiscordIcon';

interface IconProps {
  icon: string | undefined;
  className?: string;
}

const Icon = ({ icon, className = '' }: IconProps) => {
  switch (icon) {
    case 'academic-cap':
      return <AcademicCapIcon className={className} />;
    case 'arrow-right-down':
      return <ArrowRightDownIcon className={className} />;
    case 'arrow-right-down-solid':
      return <ArrowRightDownSolidIcon className={className} />;
    case 'arrow-right-up-circle':
      return <ArrowRightUpCircle className={className} />;
    case 'at-symbol':
      return <AtSymbolIcon className={className} />;
    case 'book-open':
      return <BookOpenIcon className={className} />;
    case 'briefcase':
      return <BriefcaseIcon className={className} />;
    case 'calendar':
      return <CalendarIcon className={className} />;
    case 'chat-alt-2':
      return <ChatAlt2Icon className={className} />;
    case 'check-circle-solid':
      return <CheckCircleIcon className={className} />;
    case 'chevron-double-down':
      return <ChevronDoubleDownIcon className={className} />;
    case 'chevron-left':
      return <ChevronLeftIcon className={className} />;
    case 'chevron-right':
      return <ChevronRightIcon className={className} />;
    case 'clock':
      return <ClockIcon className={className} />;
    case 'cloud':
      return <CloudIcon className={className} />;
    case 'cursor-click':
      return <CursorClickIcon className={className} />;
    case 'desktop-computer':
      return <DesktopComputerIcon className={className} />;
    case 'discord':
      return <DiscordIcon className={className} />;
    case 'exclamation-circle':
      return <ExclamationCircleIcon className={className} />;
    case 'fire':
      return <FireIcon className={className} />;
    case 'heart':
      return <HeartIcon className={className} />;
    case 'light-bulb':
      return <LightBulbIcon className={className} />;
    case 'location-marker':
      return <LocationMarkerIcon className={className} />;
    case 'mail':
      return <MailIcon className={className} />;
    case 'pencil':
      return <PencilIcon className={className} />;
    case 'puzzle':
      return <PuzzleIcon className={className} />;
    case 'receipt-tax':
      return <ReceiptTaxIcon className={className} />;
    case 'sparkles':
      return <SparklesIcon className={className} />;
    case 'star':
      return <StarIcon className={className} />;
    case 'ticket':
      return <TicketIcon className={className} />;
    case 'trending-up':
      return <TrendingUpIcon className={className} />;
    case 'user-circle':
      return <UserCircleIcon className={className} />;
    case 'user-group':
      return <UserGroupIcon className={className} />;
    case 'video-camera':
      return <VideoCameraIcon className={className} />;
    case 'cross':
      return <XIcon className={className} />;
    case 'plus':
      return <PlusIcon className={className} />;
    default:
      return null;
  }
};

export default Icon;
